import * as React from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  MenuItem,
  Modal,
  Select,
  TextField
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Postrequestcall } from "../../request/Postrequest";
import {
  DELETE_TIMESHEETS,
  DELETE_TIMESHEETS_ENTRIES,
  DELETE_TIMESHEETS_GOALS,
  DELETE_TIMESHEETS_PITURES,
  SAVE_TIMEHSEET_GOALS,
  SAVE_TIMESHEETS,
  SAVE_TIMESHEETS_ENTRIES,
  SAVE_TIMESHEETS_PICTURES
} from "../../constant/Apipath";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import "./Addtimesheet.css";
import AddJobTimesheet from "./models/AddJobTimesheet";
import { useEffect, useState } from "react";
import { Stack, Typography, IconButton } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import PromptModal from "../common/PromptModal";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { formatNumericToTime } from "./utils/timesheetUtils";

const AddEditTimesheetModel = ({
  open,
  onClose,
  operation,
  initialUser,
  selectedJob,
  setSelectedJob,
  loginData,
  goallist,
  userGoalData,
  onSaveComplete,
  onJoblistOpen,
  onGoalModalOpen,
  deletedEntries = [],
  setDeletedEntries,
  deletedImages = [],
  setDeletedImages,
  deletedGoalsCategories = [],
  setDeletedGoalsCategories
}) => {
  const dispatch = useDispatch();
  const { multiLanguageData } = useSelector((state) => state?.main);

  // ✅ FIXED: Separate loading states for save and delete
  const [dateError, setDateError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [currentInitialUser, setCurrentInitialUser] = useState(initialUser);
  const [roleIndex, setRoleIndex] = useState(1);

  // Language data
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    TEXT_ADD_TIMESHEET = English.TimeSheet.TEXT_ADD_TIMESHEET,
    EDIT_TIMESHEET = English.TimeSheet.EDIT_TIMESHEET,
    TEXT_TOTAL_CAPS = English.TimeSheet.TEXT_TOTAL_CAPS,
    TEXT_KM = English.TimeSheet.TEXT_KM,
    TEXT_MI = English.TimeSheet.TEXT_MI,
    TEXT_TIMESHEET_DATE = English.TimeSheet.TEXT_TIMESHEET_DATE,
    BUTTON_ADD_JOB = English.TimeSheet.BUTTON_ADD_JOB,
    TEXT_DISCARD = English.TimeSheet.TEXT_DISCARD,
    TEXT_DISCARD_DIALOG_TITLE = English.TimeSheet.TEXT_DISCARD_DIALOG_TITLE,
    TEXT_DISCARD_DIALOG_DESC = English.TimeSheet.TEXT_DISCARD_DIALOG_DESC,
    TEXT_DELETE_TIMESHEET_TITLE = English.TimeSheet.TEXT_DELETE_TIMESHEET_TITLE,
    BUTTON_DELETE = English.TimeSheet.BUTTON_DELETE,
    TEXT_DELETE_TIMESHEET_DESCRIPTION = English.TimeSheet.TEXT_DELETE_TIMESHEET_DESCRIPTION
  } = LanguageData || {};

  const labelArray = [
    { key: 1, value: TEXT_KM },
    { key: 2, value: TEXT_MI }
  ];

  // ✅ FIXED: Calculate totals dynamically from current selectedJob
  const calculateTotals = () => {
    const totalHours = selectedJob.reduce((sum, job) => {
      const jobHours = parseFloat(job.hours) || 0;
      return sum + jobHours;
    }, 0);

    const totalDist = selectedJob.reduce((sum, job) => {
      const jobDistance = parseFloat(job.distance) || 0;
      return sum + jobDistance;
    }, 0);

    return { totalHours, totalDistance: totalDist };
  };

  const { totalHours, totalDistance } = calculateTotals();

  // Initialize component data when props change
  useEffect(() => {
    if (open) {
      setCurrentInitialUser(
        initialUser || {
          timesheetDate: dayjs().format("YYYY-MM-DD"),
          totalHours: "00:00",
          isSent: false
        }
      );
    }
  }, [open, initialUser]);

  useEffect(() => {
    if (selectedJob?.length > 0) {
      const unit = selectedJob[0]?.unitOfDistance;
      setRoleIndex(unit === "mi" ? 2 : 1);
    }
  }, [selectedJob]);

  const handleClose = () => {
    // Reset all state
    setDateError(false);
    setIsSaving(false);
    setIsDeleting(false);
    setOpenConfirm(false);
    setOpenDeleteConfirm(false);
    setDeletedEntries?.([]);
    setDeletedImages?.([]);
    setDeletedGoalsCategories?.([]);
    onClose();
  };

  const addTimesheetClose = () => {
    const isObjectChanged = (obj1, obj2) => JSON.stringify(obj1) !== JSON.stringify(obj2);

    const hasChanges = () => {
      if (operation === "edit") {
        return (
          isObjectChanged(initialUser, {
            ...initialUser,
            timesheetDate: dayjs().format("YYYY-MM-DD")
          }) ||
          selectedJob.some(
            (job, index) => job.isNew || isObjectChanged(job, { ...selectedJob[index] })
          )
        );
      } else if (operation === "add") {
        return selectedJob.some((job) => job.hours > 0 || job.comments !== "" || job.siteId !== "");
      }
      return false;
    };

    if (!hasChanges()) {
      handleClose();
    } else {
      setOpenConfirm(true);
    }
  };

  const handleConfirmClose = (confirm) => {
    if (confirm) {
      handleClose();
    }
    setOpenConfirm(false);
  };

  const handleDateChange = (date) => {
    const formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : "";

    if (!formattedDate) {
      setDateError(true);
    } else {
      setDateError(false);
      setCurrentInitialUser({
        ...currentInitialUser,
        timesheetDate: formattedDate
      });
    }
  };

  const deleteData = async () => {
    try {
      // Delete goals
      if (deletedGoalsCategories?.length > 0) {
        for (const item of deletedGoalsCategories) {
          const deleteObj = {
            UserId: loginData?.userInformation?.UserId,
            ReturnRecordId: false,
            ReturnRecordError: true,
            DeleteList: [
              {
                Id: item.id,
                ModifiedBy: loginData?.userInformation?.UserId
              }
            ]
          };
          await Postrequestcall(DELETE_TIMESHEETS_GOALS, deleteObj, loginData?.accessToken);
        }
      }

      // Delete images
      if (deletedImages?.length > 0) {
        const deleteArray = deletedImages?.map((deletePic) => ({ Id: deletePic.id }));
        const deleteObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: false,
          ReturnRecordError: true,
          DeleteList: deleteArray
        };
        await Postrequestcall(DELETE_TIMESHEETS_PITURES, deleteObj, loginData?.accessToken);
      }

      // Delete entries and their associated pictures
      if (deletedEntries?.length !== 0) {
        let tempDeletePictures = [];
        deletedEntries.forEach((en) =>
          en.pictureList?.forEach((el) => tempDeletePictures.push(el))
        );
        const deletePictureArray = tempDeletePictures.map((deletePic) => ({ Id: deletePic.id }));

        if (deletePictureArray?.length > 0) {
          const deletePictureObj = {
            UserId: loginData?.userInformation?.UserId,
            ReturnRecordId: false,
            ReturnRecordError: true,
            DeleteList: deletePictureArray
          };
          await Postrequestcall(
            DELETE_TIMESHEETS_PITURES,
            deletePictureObj,
            loginData?.accessToken
          );
        }

        const deleteArray = deletedEntries.map((deleteEntry) => ({ Id: deleteEntry.id }));
        const deleteObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: false,
          ReturnRecordError: true,
          DeleteList: deleteArray
        };
        await Postrequestcall(DELETE_TIMESHEETS_ENTRIES, deleteObj, loginData?.accessToken);
      }
    } catch (err) {
      console.log("deleteData-> Error While Deleting Data: ", err);
    }
  };

  const selectedLabel = labelArray.find((label) => label.key === roleIndex)?.value || "N/A";

  const onSaveTimesheet = async () => {
    try {
      setIsSaving(true);

      // Delete removed items first
      if (
        deletedEntries.length > 0 ||
        deletedImages.length > 0 ||
        deletedGoalsCategories.length > 0
      ) {
        await deleteData();
      }

      // ✅ FIXED: Calculate total hours from current selectedJob entries
      const currentTotalHours = selectedJob.reduce((sum, job) => {
        const jobHours = parseFloat(job.hours) || 0;
        return sum + jobHours;
      }, 0);

      const currentTotalDistance = selectedJob.reduce((sum, job) => {
        const jobDistance = parseFloat(job.distance) || 0;
        return sum + jobDistance;
      }, 0);

      // ✅ FIXED: Convert total hours to decimal format for API
      const totalHoursDecimal = parseFloat(currentTotalHours.toFixed(2));

      // Save main timesheet
      const timesheetObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: currentInitialUser?.id || 0,
            TimesheetDate: dayjs(currentInitialUser?.timesheetDate || dayjs()).format("YYYY-MM-DD"),
            TotalHours: totalHoursDecimal, // ✅ FIXED: Use calculated total hours
            TotalDistance: currentTotalDistance, // ✅ FIXED: Use calculated total distance
            UnitOfDistance: selectedLabel,
            IsSent: currentInitialUser?.isSent || false,
            ModifiedBy: loginData?.userInformation?.UserId,
            TimesheetTypeId: 1,
            TimesheetStatus: 1
          }
        ]
      };

      const timesheetData = await Postrequestcall(
        SAVE_TIMESHEETS,
        timesheetObj,
        loginData?.accessToken
      );

      // Prepare timesheet entries
      const finalEntriesData = selectedJob?.map((job) => {
        let hoursFormatted = "00.00";

        if (typeof job.hours === "string") {
          if (job.hours.includes(":")) {
            const [h, m] = job.hours.split(":").map(Number);
            hoursFormatted = (h + m / 60).toFixed(2);
          } else if (job.hours.includes(".")) {
            hoursFormatted = parseFloat(job.hours).toFixed(2);
          }
        } else if (typeof job.hours === "number") {
          hoursFormatted = job.hours.toFixed(2);
        }

        return {
          Id: job.isNew ? 0 : job.id,
          TimesheetId: timesheetData.data.data[0].objData.id,
          SiteId: job.siteId,
          Hours: hoursFormatted,
          Distance: job.distance || 0,
          UnitOfDistance: selectedLabel,
          Comments: job.comments,
          CompanyId: job.companyId,
          ModifiedBy: loginData?.userInformation?.UserId,
          ProjectId: job.projectId,
          ClockInTime: "00:00",
          ClockOutTime: "00:00"
        };
      });

      const finalEntriesObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: finalEntriesData
      };

      // Save timesheet entries
      const savedEntry = await Postrequestcall(
        SAVE_TIMESHEETS_ENTRIES,
        finalEntriesObj,
        loginData?.accessToken
      );

      // Save goals if any
      const goalsSavePromises = selectedJob.flatMap(
        (job) =>
          job.timesheetGoalsArray?.map((goal) => {
            let hoursFormatted = "00.00";

            if (typeof goal.time === "string") {
              if (goal.time.includes(":")) {
                const [h, m] = goal.time.split(":").map(Number);
                hoursFormatted = (h + m / 60).toFixed(2);
              } else if (goal.time.includes(".")) {
                hoursFormatted = parseFloat(goal.time).toFixed(2);
              }
            } else if (typeof goal.time === "number") {
              hoursFormatted = goal.time.toFixed(2);
            }

            const saveGoalsDetailsObj = {
              UserId: loginData?.userInformation?.UserId,
              ReturnRecordId: true,
              ReturnRecordError: true,
              SaveList: [
                {
                  Id: goal.id || 0,
                  TimeSheetId: timesheetData.data.data[0].objData.id,
                  TimeSheetEntryId: savedEntry?.data?.data?.find(
                    (entry) => entry.objData?.comments.toLowerCase() === job.comments.toLowerCase()
                  )?.objData?.id,
                  SiteId: job.siteId,
                  GoalId: goal.goalId,
                  goalCategoryId: goal.categoryId || 0,
                  Hours: hoursFormatted,
                  ModifiedBy: loginData?.userInformation?.UserId,
                  ProjectId: job.projectId
                }
              ]
            };

            return Postrequestcall(
              SAVE_TIMEHSEET_GOALS,
              saveGoalsDetailsObj,
              loginData?.accessToken
            );
          }) || []
      );

      if (goalsSavePromises.length > 0) {
        await Promise.all(goalsSavePromises);
      }

      // Save images
      for (let job of selectedJob) {
        const newPictures = job.pictureList?.filter((pic) => !pic.id) || [];
        if (newPictures.length > 0) {
          let timesheetEntry = job.isNew
            ? savedEntry?.data?.data.find(
                (entry) =>
                  entry.objData?.comments.toLowerCase() === job.comments.toLowerCase() &&
                  formatNumericToTime(entry.objData?.hours) &&
                  entry.objData?.distance === job.distance &&
                  entry.objData?.siteId === job.siteId
              )
            : job;

          for (let picture of newPictures) {
            const formData = new FormData();
            formData.append("Id", 0);
            formData.append("TimeSheetId", timesheetData.data.data[0].objData.id);
            formData.append(
              "TimeSheetEntryId",
              job.isNew ? timesheetEntry?.objData?.id : timesheetEntry?.id
            );
            formData.append("SiteId", job.siteId);
            formData.append("ProjectId", job.userSiteProjectId || job.projectId);
            formData.append("ModifiedBy", loginData?.userInformation?.UserId);
            formData.append("PictureUrl", picture);

            await Fileuploadrequestcall(SAVE_TIMESHEETS_PICTURES, formData, loginData?.accessToken);
          }
        }
      }

      // Notify parent component of successful save
      if (onSaveComplete) {
        await onSaveComplete();
      }

      handleClose();
    } catch (error) {
      console.error("onSaveTimesheet-> Error When Saving Timesheet: ", error);
    } finally {
      setIsSaving(false);
    }
  };

  const onDeleteButtonPressed = () => {
    setOpenDeleteConfirm(true);
  };

  // ✅ FIXED: Updated handleDeleteConfirm with proper loading state
  const handleDeleteConfirm = async (confirm) => {
    setOpenDeleteConfirm(false);
    if (confirm) {
      try {
        setIsDeleting(true);

        const deleteObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: false,
          ReturnRecordError: true,
          DeleteList: [
            {
              Id: currentInitialUser?.id,
              ModifiedBy: loginData?.userInformation?.UserId
            }
          ]
        };
        await Postrequestcall(DELETE_TIMESHEETS, deleteObj, loginData?.accessToken);

        // Notify parent component of successful delete
        if (onSaveComplete) {
          await onSaveComplete();
        }

        handleClose();
      } catch (err) {
        console.log("handleDeleteConfirm-> Error While Deleting Timesheet: ", err);
      } finally {
        setIsDeleting(false);
      }
    }
  };

  // ✅ FIXED: Check if any operation is in progress
  const isAnyOperationInProgress = isSaving || isDeleting;

  return (
    <>
      <Modal open={open} onClose={addTimesheetClose}>
        <Box className="user-modal-responsive">
          {isAnyOperationInProgress ? (
            <Box sx={{ alignItems: "center",  justifyContent: "center",  display: "flex" }}   height="100vh">
              <CircularProgress size={24} sx={{ color: "#3A75C4" }} />
            </Box>
          ) : (
            <>
              <Stack sx={{ alignItems: { xs: "flex-start", sm: "center", justifyContent: "space-between" }} } direction={{ xs: "column", sm: "row" }}>
                <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} width={{ xs: "100%", sm: "40%" }}>
                  <Typography sx={{ fontWeight: "bold" }} variant="h6">
                    {operation === "edit" ? EDIT_TIMESHEET : TEXT_ADD_TIMESHEET}
                  </Typography>

                  <Stack sx={{ display: { xs: "flex", sm: "none"  }}} direction={"row"}>
                    <IconButton
                      size="small"
                      onClick={addTimesheetClose}
                      disabled={isAnyOperationInProgress}>
                      <CloseIcon />
                    </IconButton>

                    {/* ✅ FIXED: Save button with proper loading state */}
                    <IconButton
                      onClick={onSaveTimesheet}
                      color="primary"
                      disabled={
                        isAnyOperationInProgress ||
                        dateError ||
                        !selectedJob?.length ||
                        selectedJob.some((job) => !job || job.hours === 0)
                      }>
                      {isSaving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                    </IconButton>

                    {/* ✅ FIXED: Delete button with proper loading state */}
                    {operation !== "add" && (
                      <IconButton
                        onClick={onDeleteButtonPressed}
                        color="secondary"
                        disabled={isAnyOperationInProgress}
                        aria-label="delete">
                        {isDeleting ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          <DeleteIcon />
                        )}
                      </IconButton>
                    )}
                  </Stack>
                </Stack>

                <Stack direction={"row"} sx={{ alignItems: "center" }}>
                  <Stack sx={{ alignItems: "center", justifyContent: "space-between" }} direction={"row"} spacing={1}>
                    <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
                      {/* ✅ FIXED: Show dynamically calculated totals */}
                      <Typography sx={{ fontWeight: "bold" }}>
                        {TEXT_TOTAL_CAPS}: {formatNumericToTime(totalHours)}
                      </Typography>
                      <Typography sx={{ fontWeight: "bold" }}>{totalDistance.toFixed(2)}</Typography>

                      <FormControl size="small">
                        <Select
                          value={roleIndex}
                          onChange={(e) => {
                            const value = e.target.value;
                            const data = [...selectedJob];
                            for (let i = 0; i < data?.length; i++) {
                              data[i].unitOfDistance = value === 1 ? "km" : "mi";
                            }
                            setSelectedJob(data);
                            setRoleIndex(value);
                          }}
                          displayEmpty
                          disabled={isAnyOperationInProgress}
                          inputProps={{ "aria-label": "Without label" }}>
                          {labelArray.map((v, i) => (
                            <MenuItem key={i} value={v.key}>
                              {v.value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Stack>

                    {/* ✅ FIXED: Desktop buttons with proper loading states */}
                    <Stack sx={{ display: { xs: "none", sm: "flex", alignItems: "center" }} } direction={"row"}>
                      <IconButton
                        size="small"
                        onClick={addTimesheetClose}
                        disabled={isAnyOperationInProgress}>
                        <CloseIcon />
                      </IconButton>

                      <IconButton
                        color="primary"
                        onClick={onSaveTimesheet}
                        disabled={
                          isAnyOperationInProgress ||
                          dateError ||
                          !selectedJob?.length ||
                          selectedJob.some((job) => !job || job.hours === 0)
                        }>
                        {isSaving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                      </IconButton>

                      {operation !== "add" && (
                        <IconButton
                          onClick={onDeleteButtonPressed}
                          color="secondary"
                          disabled={isAnyOperationInProgress}>
                          {isDeleting ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            <DeleteIcon />
                          )}
                        </IconButton>
                      )}
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>

              <Stack sx={{ gap: 1.5,  marginTop: 2  }} >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    enableAccessibleFieldDOMStructure={false}
                    value={dayjs(currentInitialUser?.timesheetDate || dayjs())}
                    format="MMM DD, YYYY"
                    onChange={handleDateChange}
                    label={TEXT_TIMESHEET_DATE}
                    disabled={isAnyOperationInProgress}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={dateError}
                        helperText={dateError ? "Invalid Date" : ""}
                        disabled={isAnyOperationInProgress}
                      />
                    )}
                  />
                </LocalizationProvider>

                <AddJobTimesheet
                  selectedJob={selectedJob}
                  setSelectedJob={setSelectedJob}
                  goallist={goallist}
                  userGoalData={userGoalData}
                  loginData={loginData}
                  disabled={isAnyOperationInProgress}
                  onGoalModalOpen={onGoalModalOpen}
                  roleIndex={roleIndex}
                  deletedEntries={deletedEntries}
                  setDeletedEntries={setDeletedEntries}
                  deletedImages={deletedImages}
                  setDeletedImages={setDeletedImages}
                  deletedGoalsCategories={deletedGoalsCategories}
                  setDeletedGoalsCategories={setDeletedGoalsCategories}
                />

                <Button
                  onClick={onJoblistOpen}
                  variant="contained"
                  fullWidth
                  size="medium"
                  disabled={isAnyOperationInProgress}>
                  {BUTTON_ADD_JOB}
                </Button>
              </Stack>
            </>
          )}
        </Box>
      </Modal>

      <PromptModal
        isOpen={openConfirm}
        onClose={() => handleConfirmClose(false)}
        title={TEXT_DISCARD_DIALOG_TITLE}
        desc={TEXT_DISCARD_DIALOG_DESC}
        redButtonText={TEXT_DISCARD}
        onRedButtonClick={() => handleConfirmClose(true)}
      />
      <PromptModal
        isOpen={openDeleteConfirm}
        onClose={() => handleDeleteConfirm(false)}
        title={TEXT_DELETE_TIMESHEET_TITLE}
        desc={TEXT_DELETE_TIMESHEET_DESCRIPTION}
        redButtonText={BUTTON_DELETE}
        onRedButtonClick={() => handleDeleteConfirm(true)}
      />
    </>
  );
};

export default AddEditTimesheetModel;

